import { CommonStrings } from "../../../common/classes/CommonStrings";

export class TimemachineRouteDefs {
  public static FEATURE_PATH = "zeitmaschine";

  public static ZeitmaschineSettings_PATH = `${CommonStrings.KW_UPDATE}`;
  public static ZeitmaschineSettings_FQ_PATH = `${this.FEATURE_PATH}/${this.ZeitmaschineSettings_PATH}`;

  public static getFQTimeMachinePath = () => this.ZeitmaschineSettings_FQ_PATH;
}
